import ImageCollectionPage from "../components/ImageCollectionPage";

export default function MarriageCeremony() {
  return <ImageCollectionPage title="Marriage Ceremony" path="/culture/marriage" collection="culture_marriage" />;
}
